import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { cardStyle, contentBoxStyle } from "../shared/Theme";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import { blueGradientBackground, pink } from "../shared/colours";
import { ArrowCircleUpSharp, MoreHoriz } from "@mui/icons-material";
import companyService from "../services/companyService";
import reportService from "../services/reportService";
import AccountGuardModal from "../elements/Admin/AccountGuardModal";
import alertService from "../services/alertService";

const ReportGenerator = () => {
	
	let [ showGuard, setShowGuard ] = useState(false);
	
	const handleExecutiveSummaryClick = async () => {
		if (companyService.selectedCompany.id === 108) {
			alertService.show(`This service is currently unavailable for the demonstration account`);
			return;
		}
		if (!companyService.selectedCompany.kynd_org_id) {
			setShowGuard(true);
			return;
		}
		reportService.executiveSummary(companyService.selectedCompany);
	}
	
	const handleAttackerViewReportClick = async () => {
		if (companyService.selectedCompany.id === 108) {
			alertService.show(`This service is currently unavailable for the demonstration account`);
			return;
		}
		if (!companyService.selectedCompany.kynd_org_id) {
			setShowGuard(true);
			return;
		}
		reportService.attackerViewReport(companyService.selectedCompany);
	}
	
	const handleRiskReductionReportClick = async () => {
		alertService.show(`Insufficient Data - the system requires more data over a longer time period in order to generate this Report.`);
		// reportService.riskReductionReport(companyService.selectedCompany);
	}
	
	const handleCyberRiskReportClick = async () => {
		if (companyService.selectedCompany.id === 108) {
			alertService.show(`This service is currently unavailable for the demonstration account`);
			return;
		}
		if (!companyService.selectedCompany.kynd_org_id) {
			setShowGuard(true);
			return;
		}
		reportService.cyberRiskReport(companyService.selectedCompany);
	}
	
	const handleDarkWebReportClick = async () => {
		if (companyService.selectedCompany.id === 108) {
			alertService.show(`This service is currently unavailable for the demonstration account`);
			return;
		}
		if (!companyService.selectedCompany.breachaware_id) {
			setShowGuard(true);
			return;
		}
		reportService.darkWebReport(companyService.selectedCompany);
	}
	
	const handleCyberTrainingReportClick = async () => {
		if (companyService.selectedCompany.id === 108) {
			alertService.show(`This service is currently unavailable for the demonstration account`);
			return;
		}
		if (!companyService.selectedCompany.usecure_id) {
			setShowGuard(true);
			return;
		}
		reportService.cyberTrainingReport(companyService.selectedCompany);
	}
	
	const handlePolicyProcessReportClick = async () => {
		if (companyService.selectedCompany.id === 108) {
			alertService.show(`This service is currently unavailable for the demonstration account`);
			return;
		}
		if (!companyService.selectedCompany.usecure_id) {
			setShowGuard(true);
			return;
		}
		reportService.policyProcessReport(companyService.selectedCompany);
	}
	
	const handleGuardClose = () => {
		setShowGuard(false);
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Cyber Insurance"/>
				<Box sx={contentBoxStyle}>
					<Stack sx={{ ...cardStyle, minWidth: "90%", margin: "auto", padding: "1em" }} justifyContent="center">
						<Typography
							variant="h5"
							sx={{ width: "100%", textAlign: "center", fontWeight: "bold" }}
						>
							Report Generator
						</Typography>
						<Typography
							sx={{
								width: "100%",
								textAlign: "center",
								margin: "2em 0 3em 0",
								fontSize: "1em"
							}}
						>
							Generate a variety of Reports to visualise and understand your Organisation'
							Cyber Risk<br/>
							Exposure, what to do about it, and see how your
							<span style={{ fontWeight: "bold" }}>Active Cyber Risk Management<br/>Programme </span>
							is helping to{` `}
							<span style={{fontWeight: "bold", textDecoration: "underline", color: pink }}>reduce</span>
							{` `}your Organisation's exposure to Cyber Risk over time
						</Typography>
						<Stack direction="row" justifyContent="center" alignItems="center" spacing={3} sx={{ width: "100%" }}>
							<Stack direction="row" spacing={3}>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="center"
									spacing={6}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "4em 1.2em" }}
								>
									<Typography sx={{ fontSize: "1.5em", fontWeight: "bold", textAlign: "center" }}>
										Executive<br/>
										Summary
									</Typography>
									<Typography sx={{ textAlign: "center" }}>
										An Overview<br/>
										Report detailing<br/>
										the Top 5 Issues<br/>
										exposing your<br/>
										Organisation to<br/>
										Cyber Risk right<br/>
										now
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "12em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handleExecutiveSummaryClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "2em",
												height: "2em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="center"
									spacing={6}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "4em 1.2em" }}
								>
									<Typography sx={{ fontSize: "1.5em", fontWeight: "bold", textAlign: "center" }}>
										Attacker View<br/>
										Report
									</Typography>
									<Typography sx={{ textAlign: "center" }}>
										A detailed Report<br/>
										to help you<br/>
										understand how<br/>
										Attackers can<br/>
										view your<br/>
										Organisation<br/>
										right now
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "12em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handleAttackerViewReportClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "2em",
												height: "2em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="center"
									spacing={6}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "4em 1.2em" }}
								>
									<Typography sx={{ fontSize: "1.5em", fontWeight: "bold", textAlign: "center" }}>
										Risk Reduction<br/>
										Report
									</Typography>
									<Typography sx={{ textAlign: "center" }}>
										A Report to help<br/>
										show you how<br/>
										your<br/>
										Organisation's<br/>
										exposure to Cyber<br/>
										Risk has changed<br/>
										over time
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "12em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handleRiskReductionReportClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "2em",
												height: "2em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
							</Stack>
							<Stack direction="column" spacing={3}>
								<Stack
									direction="row"
									alignItems="center"
									justifyContent="center"
									spacing={4}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "2.5em 2em" }}
								>
									<Typography sx={{ fontSize: "1em", textAlign: "center", width: "8em" }}>
										Cyber Risk<br/>
										Report
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "9em",
											height: "2.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handleCyberRiskReportClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em", fontSize: "0.75em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "1.6em",
												height: "1.6em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
								<Stack
									direction="row"
									alignItems="center"
									justifyContent="center"
									spacing={4}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "2.5em 2em" }}
								>
									<Typography sx={{ fontSize: "1em", textAlign: "center", width: "8em" }}>
										Dark Web<br/>
										Report
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "9em",
											height: "2.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handleDarkWebReportClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em", fontSize: "0.75em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "1.6em",
												height: "1.6em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
								<Stack
									direction="row"
									alignItems="center"
									justifyContent="center"
									spacing={4}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "2.5em 2em" }}
								>
									<Typography sx={{ fontSize: "1em", textAlign: "center", width: "8em" }}>
										Cyber Training<br/>
										Report
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "9em",
											height: "2.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handleCyberTrainingReportClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em", fontSize: "0.75em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "1.6em",
												height: "1.6em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
								<Stack
									direction="row"
									alignItems="center"
									justifyContent="center"
									spacing={4}
									sx={{ border: "2px solid", borderRadius: "1em", padding: "2.5em 2em" }}
								>
									<Typography sx={{ fontSize: "1em", textAlign: "center", width: "8em" }}>
										Policy {`&`} Process<br/>
										Report
									</Typography>
									<MoreHoriz sx={{ color: pink, width: "1.5em", height: "1.5em" }}/>
									<Stack
										direction="row"
										sx={{
											width: "9em",
											height: "2.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										spacing={0.5}
										onClick={handlePolicyProcessReportClick}
									>
										<Typography
											sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em", fontSize: "0.75em" }}
										>
											Create Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "1.6em",
												height: "1.6em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
								</Stack>
							</Stack>
						</Stack>
					</Stack>
				</Box>
				<AccountGuardModal
					open={showGuard}
					onClose={handleGuardClose}
				/>
			</Box>
		</Box>
	);
}

export default ReportGenerator;
